import { useScrollReveal } from "@/hooks/useScrollReveal";
import { booker } from "@/content";

const steps = booker.howItWorks.steps;

export default function HowItWorks() {
  const { ref: headerRef, revealed: headerRevealed } = useScrollReveal();

  return (
    <section id="how-it-works" className="py-24 bg-gray-50 dark:bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full bg-cyan-200/20 dark:bg-cyan-500/10 blur-[140px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div
          ref={headerRef}
          className={`text-center mb-16 transition-all duration-700 ${
            headerRevealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-gray-200 dark:bg-slate-800/60 text-gray-600 dark:text-slate-400 text-xs font-semibold tracking-widest uppercase mb-6">{booker.howItWorks.badge}</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-gray-900 dark:text-white leading-tight mb-4">{booker.howItWorks.title}</h2>
          <p className="text-gray-600 dark:text-slate-400 text-lg leading-relaxed max-w-2xl mx-auto">{booker.howItWorks.subtitle}</p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Desktop line */}
          <div className="hidden lg:block absolute top-[72px] left-[16%] right-[16%] h-px bg-gradient-to-r from-gray-200 via-cyan-300 to-gray-200 dark:from-slate-800 dark:via-cyan-500/40 dark:to-slate-800" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            {steps.map((step, i) => (
              <StepCard key={step.num} step={step} index={i} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

function StepCard({
  step,
  index,
}: {
  step: { num: string; title: string; desc: string; icon: string };
  index: number;
}) {
  const { ref, revealed } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`relative flex flex-col items-center text-center transition-all duration-700 ${
        revealed ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}
      style={{ transitionDelay: `${index * 150}ms` }}
    >
      <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-cyan-50 dark:bg-slate-800/50 border border-cyan-200 dark:border-slate-700/50 mb-5 relative z-10">
        <i className={`${step.icon} text-cyan-600 dark:text-cyan-400 text-2xl`}></i>
      </div>
      <span className="text-cyan-600 dark:text-cyan-400 font-extrabold text-2xl mb-2">{step.num}</span>
      <h4 className="text-gray-900 dark:text-white font-bold text-base mb-2">{step.title}</h4>
      <p className="text-gray-600 dark:text-slate-400 text-sm leading-relaxed">{step.desc}</p>
    </div>
  );
}
